import { defineMessages } from 'react-intl';

export default function initTags() {
  defineMessages({
    tag_barbecue: {
      id: 'tag.barbecue',
      defaultMessage: 'barbecue',
    },
    tag_buffet: {
      id: 'tag.buffet',
      defaultMessage: 'buffet',
    },
    tag_easy: {
      id: 'tag.easy',
      defaultMessage: 'easy',
    },
    tag_gift: {
      id: 'tag.gift',
      defaultMessage: 'gift',
    },
    tag_glutenfree: {
      id: 'tag.gluten-free',
      defaultMessage: 'gluten-free',
    },
    tag_hearty: {
      id: 'tag.hearty',
      defaultMessage: 'hearty',
    },
    tag_lowcarb: {
      id: 'tag.low carb',
      defaultMessage: 'low carb',
    },
    tag_lowfat: {
      id: 'tag.low fat',
      defaultMessage: 'low fat',
    },
    tag_milkfree: {
      id: 'tag.milk-free',
      defaultMessage: 'milk-free',
    },
    tag_nutfree: {
      id: 'tag.nut-free',
      defaultMessage: 'nut-free',
    },
    tag_party: {
      id: 'tag.party',
      defaultMessage: 'party',
    },
    tag_quick: {
      id: 'tag.quick',
      defaultMessage: 'quick',
    },
    tag_sauce: {
      id: 'tag.sauce',
      defaultMessage: 'sauce',
    },
    tag_sugarfree: {
      id: 'tag.sugar-free',
      defaultMessage: 'sugar-free',
    },
    tag_vegan: {
      id: 'tag.vegan',
      defaultMessage: 'vegan',
    },
    tag_vegetarian: {
      id: 'tag.vegetarian',
      defaultMessage: 'vegetarian',
    },
  });
}
